import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "../components/inputs/TextField";
import Button from "../components/buttons/Button";
import ESLogo from "../components/logo/esLogo";
import AuthContext from "../store/authContext";
import { errorAlert, makeApiRequest } from "../util";
import { AUTH_TRANSLATIONS } from "../translations/util";

import CopyRightFooter from "../components/footer/CopyRightFooter";
import { APP_NAME } from "../constants";
import PasswordField from "../components/inputs/PasswordField";

const Login = () => {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const onSubmit = useCallback(async () => {
    setLoading(true);
    try {
      const response = await makeApiRequest<{
        Token: string;
        HexMode: string;
        BulkLimit: string;
      }>({
        path: "/api/v1/app-config/api-gateway/auth/login",
        method: "POST",
        reloadOnAuthError: false,
        body: JSON.stringify({
          username,
          password,
        }),
      });
      login(response.Token, response.HexMode, response.BulkLimit);
      navigate("/overview");
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      errorAlert(e);
    } finally {
      setLoading(false);
    }
  }, [login, navigate, password, username]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.isComposing) return;
      if (event.key === "Enter" && username && password) {
        onSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [username, password, onSubmit]);

  return (
    <>
      <div className="login-screen">
        <ESLogo />
        <div className="flex justify-center w-screen items-center bg-white pt-60">
          <div className="w-full login-form-wrapper flex flex-col items-center ">
            <div className="login-header w-full mb-3">
              <h1 className="mb-0" data-cy="login-heading">
                {AUTH_TRANSLATIONS.header}
              </h1>
              <p className="mb-6" data-cy="login-description">
                {" "}
                {AUTH_TRANSLATIONS.description}{" "}
              </p>
            </div>

            <div className="login-content w-full">
              <TextField
                id="user"
                placeholder={AUTH_TRANSLATIONS.authFields.placeholder.username}
                labelText={AUTH_TRANSLATIONS.authFields.label.username}
                disabled={false}
                value={username}
                onChange={(value) => {
                  setUsername(value);
                }}
              />
              <PasswordField
                id="pass"
                placeholder={AUTH_TRANSLATIONS.authFields.placeholder.password}
                labelText={AUTH_TRANSLATIONS.authFields.label.password}
                disabled={false}
                value={password}
                onChange={(value: string) => {
                  setPassword(value);
                }}
              />

              <div className="mt-4">
                <Button
                  loading={loading}
                  className="w-full"
                  label={AUTH_TRANSLATIONS.btnLabels.submit}
                  disabled={!username || !password}
                  onClick={() => {
                    onSubmit();
                  }}
                  dataCy="login-"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CopyRightFooter
        text={APP_NAME}
        className="login-footer text-center mt-16"
      />
    </>
  );
};

export default Login;
